module.exports = __webpack_public_path__ + "img/icon_map_11_on_111.4c463297.png";